import * as go from 'gojs';
import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useClickModelConceptRelationshipLink = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const dispatch = useReduxDispatch();

  return React.useCallback(
    (item: SelectItem) => {
      if (!diagram || !item) {
        return;
      }

      const links = diagram.findLinksByExample({
        value: item.value,
        category: LinkCategory.MODEL_CONCEPT_RELATIONSHIP,
      });

      commitDiagramWhileSkippingUndoManager(
        diagram,
        (_, diagram) => setDiagramSelection(new go.Set(links), true)(diagram),
        DiagramTransaction.SET_DIAGRAM_SELECTION
      );

      const firstLink = links.first();
      if (firstLink) {
        dispatch(
          uiSlice.actions.changedEntityDrawer({
            projectId,
            drawer: {
              entityValue: firstLink.data.value,
              type: EntityDrawerType.RELATIONSHIP,
            },
          })
        );
      }
    },
    [diagram, dispatch, projectId]
  );
};
